import { forEach as _forEach, cloneDeep as _cloneDeep } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const getViewerDocFiles = doc => {
  const res = [];

  _forEach(doc, doc => {
    _forEach(doc.getFiles(), (file, j) => {
      const viewerFile = _cloneDeep(file);
      viewerFile.getId = doc.getId; // quick and dirty way to have the documnt id in the viewer
      viewerFile.page = j;

      res.push(viewerFile);
    });
  });

  return res;
};
